import type { IconData } from '@stacksjs/iconify-core'

export const wrapArch: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 4C12.963 4 6.91 7.97 4.403 10.17C3.423 11.03 3 12.306 3 13.609V43.01c0 .96 1.404 1.525 2.159.933C8.029 41.694 13.947 38.4 24 38.4s15.97 3.293 18.841 5.544c.755.592 2.159.027 2.159-.933V13.608c0-1.303-.424-2.578-1.403-3.437C41.09 7.969 35.037 4 24 4\"/><path d=\"M3 28.6S8.727 21 24 21s21 7.6 21 7.6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default wrapArch
